export default {
  computed: {
    isDeveloperUser() {
      if(!this.$store.state.profile || !this.$store.state.profile.profileUser)
        return false
      return !!this.$store.state.profile.profileUser.isDeveloper
    }
  },
  methods: {
    developerCheckIsDeveloperBuild() {
      return !!this.$glass.isLocalSite
    }
  }
}